module.exports = __webpack_public_path__ + "media/images/faces/male/41-260f8d10300f1adc9145dd278cbccb3b.jpg";